import Index from "./index.vue"

export default [
  {
    path: "/home",
    name: "home",
    component: Index,
    title: "Home",
    children: [],
  },
]
